import { Avatar, Container, SxProps, Typography, useTheme } from '@mui/material';
import React from 'react';

import { useAuth } from '@verantos-dev/core-auth';
import { Icon } from '@verantos-dev/shared-components';
import { MessageLegacy } from '@verantos-dev/types-cohorts';

import { getLocalDateAndTime } from '../../helpers/helpers';

export const ResearchAssistantMessage = ({
  message,
  currentUser,
  type,
  timestamp,
  sx = {},
}: MessageLegacy & { sx?: SxProps }) => {
  const theme = useTheme();
  const {
    user: { userInitials },
  } = useAuth();

  const isUserRA = currentUser === 'research_assistant';
  const isInfoMessage = Boolean(type);

  const containerStyle: SxProps = {
    display: 'flex',
    gap: theme.spacing(2),
    flexDirection: 'row',
    '&.MuiContainer-root': {
      padding: '0',
      margin: `${theme.spacing(5)} 0 0`,
    },
  };

  const infoMessageContainerStyles: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    '&.MuiContainer-root': {
      padding: '0',
      margin: `${theme.spacing(0)} 0 0`,
    },
    justifyContent: 'center',
    alignItems: 'center',
  };

  const normalMessageStyles: SxProps = {
    paddingInline: theme.spacing(3),
    paddingBlock: isUserRA ? 0 : theme.spacing(2),
    color: theme.palette.text.primary,
    paddingTop: isUserRA ? 0 : undefined,
    borderRadius: '.8rem',
    backgroundColor: !isUserRA ? '#eee' : undefined,
  };

  const infoMessageStyles = {
    margin: theme.spacing(2),
    padding: theme.spacing(1),
  };

  const infoMessage = isInfoMessage ? <span> -- {getLocalDateAndTime(timestamp)}</span> : null;

  return (
    <Container
      sx={{
        ...(isInfoMessage ? infoMessageContainerStyles : containerStyle),
        ...sx,
      }}
    >
      {!type || !isInfoMessage ? (
        <Avatar
          alt={isUserRA ? 'RA' : userInitials}
          sx={{
            width: theme.spacing(6),
            height: theme.spacing(6),
            fontSize: theme.spacing(3),
            fontWeight: '700',
            backgroundColor: theme.palette.secondary.main,
          }}
        >
          {isUserRA ? <Icon id="test" icon="verantosLogo" /> : userInitials}
        </Avatar>
      ) : null}
      <Typography
        sx={isInfoMessage ? infoMessageStyles : normalMessageStyles}
        variant={isInfoMessage ? 'caption' : 'body2'}
      >
        {typeof message === 'string'
          ? message.split('\n').map((line, index) => (
              <span key={index}>
                {line}
                {infoMessage}
                <br />
              </span>
            ))
          : message}
      </Typography>
    </Container>
  );
};
